import Rete from "rete";
import { BodyControl } from "../Controls/BodyControl";
import { StatusControl } from "../Controls/StatusControl";
import { actionSocket } from "../Sockets/Sockets";

export class EndCardNode extends Rete.Component {
    static type = "EndCard";
    public task:any;

    constructor() {
        super(EndCardNode.type);
        this.task = {
            outputs: {}
        };
    }

    builder(node) {
        //console.log("Create Card", "EndCard", node.id, node.data);

        if(node.data.body === undefined && node.name === 'EndCard'){
            node.data = {
                label: "End Card",
                properties: [],
                header: [],
                status: "processing",
                body: ["입력하세요.",{"cat":2,"type": 0, "action":["","","",""],"rules":[]},1,""],
                actions: []
            };
        }

        node.data.body[1].cat = 2;
        const body = new BodyControl(
            this.editor,
            node.data.body,
            node.id + "_BODY",
            EndCardNode.type
        );

        const status = new StatusControl(
            this.editor,
            node.data.status,
            node.id + "_STATUS",
            EndCardNode.type
        );

        node.addControl(status).addControl(body);
        

        if ( node.data.properties && !node.data.properties.includes("ENTRY_POINT")) {
            node.addInput(new Rete.Input("act", "Link", actionSocket, true));
        }

        if (node.data.actions) {
            node.data.actions.forEach(action => {
                node.addOutput( new Rete.Output(action.id, action.text, actionSocket, false));
            });
        }
        
        return node;
    }

    worker(node, inputs, outputs) {
        //console.log("EndCard", "worker", node.id, node.data);
        if (!this.editor)
            return
        const nodeRef = this.editor.nodes.find(it => it.id === node.id)
        if (!nodeRef)
            return
    }
}
